module.exports = __webpack_public_path__ + "img/testimonial-tammy.9c794ca2.png";